import script from "./ProjectSelectedClientItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectSelectedClientItem.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectSelectedClientItem.vue?vue&type=style&index=0&id=7bf158a1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bf158a1"]])

export default __exports__